module.exports = __webpack_public_path__ + "img/businessScopeImg3.7a902d22.png";